import Bottom from "./AlignBottom";
import Center from "./AlignCenter";
import Left from "./AlignLeft";
import Middle from "./AlignMiddle";
import Right from "./AlignRight";
import Top from "./AlignTop";

export default {
    Bottom,
    Center,
    Left,
    Right,
    Middle,
    Top,
};
